export enum CustomErrorCode {
  AccountLocked = 'AccountLocked',
  ResetTokenAlreadyExists = 'ResetTokenAlreadyExists',
  RateHourlyLimitExceeded = 'RateHourlyLimitExceeded',
  RateDailyLimitExceeded = 'RateDailyLimitExceeded',
  ConcurrencyConflict = 'ConcurrencyConflict',
  IntegrationError = 'IntegrationError',
  ValidationError = 'ValidationError', 
  GeocodingError = 'GeocodingError',
  InternalError = 'InternalError',
  TenantDisabled = 'TenantDisabled'
}
